import { configureStore } from '@reduxjs/toolkit'
import langReducer from '../slice/lang'
import rateReducer from '../slice/dollar'
import userDataReducer from '../slice/userData'

export const store = configureStore({
    reducer: {
        lang:langReducer,
        rate:rateReducer,
        userData:userDataReducer
    },
})